import geniatech from "../../../services/apis/geniatech";
import * as type from "../../../services/types/location-type";
import { toast } from "react-toastify";
import axios from "axios";

export const getCountries = () => async (dispatch) => {
  axios
    .get("https://api.tizeti.com/api/v1/legacy/get_list_of_regions", {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    })
    .then((res) => {
      if (res.status === 200) {
        dispatch({
          type: type.GET_COUNTRIES,
          payload: res.data,
        });
      }
    })
    .catch(() => {
      toast.error("Unable to get states");
    });
};

export const getCities = (data) => async (dispatch) => {
  dispatch({ type: type.GETTING_CITIES, payload: true });
  geniatech
    .post("/index.php", data)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: type.GET_CITIES,
          payload: res.data.items,
        });
      }
    })
    .catch(() => {
      toast.info("Unable to get cities");
      dispatch({ type: type.GETTING_CITIES, payload: true });
    });
};
